import "./Footer.css";
import { Link } from "react-router-dom";
import Logo from "../../src/Logo/A1LogoNoBackgroud.png";

export function Footer({ t }) {
  const currentYear = new Date().getFullYear();

  const developers = ["Rubeth Rokonuzzaman", "Thomas Dubois", "Nathan Demosthene"];

  const goTop = () => window.scrollTo({ top: 0, behavior: "smooth" });

  return (
    <footer className="footer">
      <div className="footer-inner">
        <div className="footer-top">
          <div className="footer-box footer-brand">
            <Link to="/" className="footer-logo-link" onClick={goTop}>
              <img src={Logo} alt="A1 Tutorial" className="logocta" />
            </Link>
            <div className="footer-brand-text">
              <h4 className="notranslate" translate="no">A1 Tutorial</h4>
              <p>{t.AddressStreet}</p>
              <p>{t.AddressCity}</p>
              <p>
                {t.Email}:{" "}
                <a href="mailto:a1tutorial@gmail.com">a1tutorial@gmail.com</a>
              </p>
              <p>
                {t.Phone}: <a href="tel:+15146906696">(514) 690-6696</a>
              </p>
            </div>
          </div>

          <div className="footer-box">
            <h4>{t.Navigation}</h4>
            <nav className="footer-links">
              <Link to="/" onClick={goTop}>{t.Home}</Link>
              <Link to="/AboutUs" onClick={goTop}>{t.AboutUs}</Link>
              <Link to="/contact" onClick={goTop}>{t.Contact}</Link>
              <Link to="/courses" onClick={goTop}>{t.Courses}</Link>
            </nav>
          </div>

          <div className="footer-box">
            <h4>{t.CentreHours}</h4>
            <p>{t.GroupDaysWeek} : 4:30 PM - 7:30 PM</p>
            <p>{t.GroupDaysWeekend} : 11:00 AM - 1:00 PM</p>
            <p>{t.GroupDayClose} : {t.Dayclose}</p>
          </div>
        </div>

        <div className="footer-copy">
          <span className="footer-legal">
            <span>&copy; {currentYear}</span>
            <span className="notranslate" translate="no">A1 Tutorial</span>
            <span className="footer-sep" aria-hidden="true">|</span>
            <span>{t.AllRightsReserved}</span>
          </span>
          <span className="footer-sep footer-sep-credit" aria-hidden="true">|</span>
          <span className="footer-credit">
            <span>{t.DevelopedBy}</span>
            <span className="footer-names">
              {developers.map((name) => (
                <span key={name} className="notranslate" translate="no">{name}</span>
              ))}
            </span>
          </span>
        </div>
      </div>
    </footer>
  );
}
